export default function getResource(label, vars = []) {
    const resources = {
        title: 'Confirm Your Security Code',
        confirmSecurityCode: 'Please confirm your credit card security code.',
        securityCodeLabel: 'Security Code',
        changePaymentMethod: 'Change Payment Method',
        confirmPlaceOrder: 'Confirm and Place Order'
    };
    return resources[label];
}
